import script from "./LibraryHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./LibraryHeader.vue?vue&type=script&setup=true&lang=ts"

import "./LibraryHeader.vue?vue&type=style&index=0&id=4c90feac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c90feac"]])

export default __exports__